import { useMemo } from 'react';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteIcon from 'assets/icons/TableDelete.png';

export const 
useEmployeeColumns = ({
  t,
  allBusinessList,
  handleEmployeeState,
  handleEdit,
  handleDelete,
  handleEditRow,
  loadingRowId,
  loadingRowBusinessId,
}) => {
  return useMemo(
    () => [
      {
        field: 'firstname',
        headerName: t('First Name'),
        flex: 1,
        sortable: false,
      },
      {
        field: 'lastname',
        headerName: t('Last Name'),
        flex: 1,
        sortable: false,
      },
      {
        field: 'businesses',
        headerName: t('Business & Job'),
        flex: 1,
        sortable: false,
        renderCell: ({ row }) => {
          const business = row?.businesses?.[0];
          const businessName = allBusinessList?.find(
            (item) => item?.uuid === business?.businessUuid
          )?.companyName;

          if (loadingRowBusinessId === row?.id) {
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  maxWidth: '115px',
                  height: '100%',
                }}
              >
                <CircularProgress size={25} />
              </Box>
            )
          }

          return (
            <Typography
              sx={{
                cursor: 'pointer',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                width: '100%',
                ':hover': {
                  textDecoration: 'underline',
                },
              }}
              onClick={() => handleEditRow(row)}
            >
              {businessName || '-'}
            </Typography>
          );
        },
      },
      {
        field: 'email',
        headerName: t('Email'),
        flex: 1,
        sortable: false,
        filterable: false,
        editable: false,
      },
      {
        field: 'employeeId',
        headerName: t('Employee ID'),
        flex: 1,
        sortable: false,
        filterable: false,
        editable: false,
      },
      {
        field: 'phone',
        headerName: t('Phone'),
        flex: 1,
        sortable: false,
        filterable: false,
        editable: false,
      },
      {
        field: 'actions',
        type: 'actions',
        renderCell: (params) => {
          const isLoading = loadingRowId === params?.row?.id;
          return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {isLoading ? (
              <IconButton>
                <CircularProgress size={25} />
              </IconButton>
            ) : (
              <IconButton onClick={() => handleEdit(params?.row)} disabled={isLoading}>
                <ModeEditOutlineOutlinedIcon />
              </IconButton>
            )}
            <IconButton onClick={() => handleDelete(params?.row)} disabled={isLoading}>
              <img src={DeleteIcon} alt="delete icon" />
            </IconButton>
          </Box>
          )
        },
      },
    ],
    [t, allBusinessList, handleEmployeeState, handleEdit, handleDelete, loadingRowId, loadingRowBusinessId]
  );
};
